import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/hero-video.mp4")